import { IsString, IsNotEmpty, IsOptional, IsUUID } from 'class-validator';

export class EmployeeTimezoneExceptionDto {
  @IsString()
  @IsUUID()
  @IsNotEmpty()
  id: string;

  @IsString()
  @IsNotEmpty()
  fullName: string;

  @IsString()
  @IsNotEmpty()
  personnelNumber: string;

  @IsString()
  @IsOptional()
  unitName?: string;

  @IsString()
  @IsNotEmpty()
  @IsUUID()
  timezoneId: string;

  @IsString()
  @IsNotEmpty()
  timezoneName: string;

  @IsString()
  @IsNotEmpty()
  companyName: string;

  @IsString()
  @IsNotEmpty()
  @IsUUID()
  companyId: string;
}
